import { Injectable } from '@angular/core';
import { FeatureNameEnum } from './feature-name.enum';
import { IFeatureService } from './ifeature.service';
import { ApiService } from '../index';

@Injectable()
export class FeatureService implements IFeatureService {
  public _apiService: ApiService;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  // calls the "feature/has" end point to determine if a client has access to a feature
  public has(feature: FeatureNameEnum): Promise<boolean> {
    let url: string = '/feature/has' + FeatureNameEnum[feature];
    return this._apiService.get(url);
  }

  // attempts to send an email to notify support that a client has requested access to a feature
  public requestFeature = (feature: FeatureNameEnum): Promise<boolean> => {
    let url: string = '/feature/request/' + FeatureNameEnum[feature];
    return this._apiService.get(url);
  };
}
